import React from "react";

import RiskFactorScoring from "components/RiskFactorScoring";
import TableCellWrapper from "components/VetExamsTable/TableCellWrapper";

import useStyles from "./styles";

interface IProps {
  value: number;
}

const RiskFactorScoreCell = ({ value }: IProps) => {
  const classes = useStyles();

  return (
    <TableCellWrapper centered>
      {Boolean(value) && (
        <RiskFactorScoring
          className={classes.riskScoreCellContent}
          value={value}
        />
      )}
    </TableCellWrapper>
  );
};

export default React.memo(RiskFactorScoreCell);
